import {
	IsArray,
	IsDate,
	IsEmail,
	IsEnum,
	IsObject,
	IsOptional,
	IsString,
	Length,
	ValidateIf,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';
import { UserGroup } from '../../enums';
import { IsPastDate } from '../../utils/validators';
import { FingerprintDto } from './referral-fingerprint.dto';

export class SignUpDto {
	@IsEmail()
	email: string;

	@IsString()
	@Length(3, 25)
	full_name: string;

	@Type(() => Date)
	@IsDate()
	@IsPastDate()
	birthday: Date;

	@IsOptional()
	@IsString()
	language?: string;

	@IsOptional()
	@IsString()
	country?: string;

	@IsString()
	@IsOptional()
	img_parent_id?: string;

	@ValidateIf((o: SignUpDto) => !!o.img_parent_id)
	@IsOptional()
	@IsObject()
	img_variants?: { [key: string]: string };

	@IsOptional()
	@IsArray()
	@IsString({ each: true })
	category_ids?: string[];

	@IsOptional()
	@IsString()
	referralCode?: string;

	@IsOptional()
	@IsObject()
	@ValidateNested()
	@Type(() => FingerprintDto)
	fingerprint?: FingerprintDto;

	@IsOptional()
	@IsString()
	ipAddress?: string;

	@IsOptional()
	@IsString()
	college?: string;

	@IsOptional()
	@IsEnum(UserGroup)
	group?: UserGroup;

	@IsOptional()
	@IsString()
	utmSource?: string;
}
